export default __webpack_public_path__ + "static/media/stop.094a9228.svg";